<template>
  <section class="pb-8" id="contact">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="10">
          <v-row justify="center">
            <v-col cols="12" sm="5">
              <h1 class="font-weight-light display-1">联系我们</h1>
              <h3 class="font-weight-light mt-3">
                原经理
              </h3>
<!--              <h3 class="font-weight-light mt-3">-->
<!--                dzzz-->
<!--              </h3>-->
              <h3 class="font-weight-light mt-3">
                电话: 18503878825
              </h3>
<!--              <h3 class="font-weight-light">-->
<!--                Email: jlutt@163.com-->
<!--              </h3>-->
            </v-col>
            <v-col cols="12" sm="7">

            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
    <div class="svg-border-waves text-white">
      <v-img src="~@/assets/img/borderWavesBlue.svg"/>
    </div>
<!--    <v-snackbar-->
<!--        v-model="snackbar.enabled"-->
<!--        timeout="3000"-->
<!--        right-->
<!--        top-->
<!--        :color="snackbar.color"-->
<!--    >-->
<!--      {{ snackbar.text }}-->

<!--      <template v-slot:action="{ attrs }">-->
<!--        <v-btn-->
<!--            text-->
<!--            v-bind="attrs"-->
<!--            @click="snackbar.enabled = false"-->
<!--        >-->
<!--          Fechar-->
<!--        </v-btn>-->
<!--      </template>-->
<!--    </v-snackbar>-->
  </section>
</template>

<style scoped>
#contact {
  background-color: #f4f7f5;
}

.svg-border-waves .v-image {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3rem;
  width: 100%;
  overflow: hidden;
}

</style>

<script>
// import {db} from '@/main'

export default {
  data: () => ({
    icons: ["fa-facebook", "fa-twitter", "fa-linkedin", "fa-instagram"],
    valid: true,
    name: "",
    nameRules: [
      (v) => !!v || "O campo nome é obrigatório",
      (v) => (v && v.length >= 6) || "O nome precisa ter mais de 6 caracteres",
    ],
    email: "",
    emailRules: [
      (v) => !!v || "O campo email é obrigatório",
      (v) => /.+@.+\..+/.test(v) || "O E-mail precisa ser válido",
    ],
    textArea: "",
    textAreaRules: [
      (v) => !!v || "O campo de texto é obrigatório",
      (v) => (v && v.length >= 10) || "Mínimo de 10 caracteres",
    ],
    lazy: false,
    snackbar: {
      enabled: false,
      text: '',
      color: ''
    }
  }),
  methods: {

  }
};
</script>
